"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      // 顶部搜索框form数据
      formInline: {
        card_code: '',
        //搜索关键词
        real_name: '',
        mobile: ''
      },
      dialogVisiblerisk: false,
      money: 0,
      // 商家余额
      userList: {
        count: 0
      },
      // 用户信息
      listQuery: {
        page: 1,
        page_size: 10
      },
      userform: {
        card_code: '',
        //用户添加
        real_name: '',
        mobile: ''
      },
      deviceType: 'desktop',
      // 设备类型: mobile, tablet, desktop
      dialogWidth: '30%',
      // 添加用户信息弹窗宽度
      labelPosition: 'right',
      // 标签位置
      labelWidth: '80px' // 标签宽度
    };
  },
  created: function created() {
    this.getUserList();
  },
  computed: {},
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 检测设备是否为移动端
    checkDevice: function checkDevice() {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 768) {
        // 移动设备
        this.deviceType = 'mobile';
        this.dialogWidth = '90%';
        this.labelPosition = 'top';
        this.labelWidth = '80px';
      } else if (clientWidth <= 1024) {
        // 平板设备
        this.deviceType = 'tablet';
        this.dialogWidth = '60%';
        this.labelPosition = 'right';
        this.labelWidth = '100px';
      } else {
        // 桌面设备
        this.deviceType = 'desktop';
        this.dialogWidth = '30%';
        this.labelPosition = 'right';
        this.labelWidth = '100px';
      }
    },
    // 格式化日期,需要加上时分秒的数据
    resetFilter: function resetFilter() {
      this.formInline.real_name = '';
      this.formInline.mobile = '';
      this.formInline.card_code = '';
      this.getUserList();
    },
    getUserList: function getUserList() {
      var _this = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/shopConfig/getFengKongUser/",
        method: 'put',
        data: {
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          shop_id: this.$user.data.shop,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code
        }
      }).then(function (response) {
        if (response.data) {
          _this.userList = response.data.data;
        }
        _this.listLoading = false;
      });
    },
    setUser: function setUser() {
      var _this2 = this;
      if (this.userform.real_name == '' || this.userform.card_code == '' || this.userform.mobile == '') {
        this.$message({
          message: '请填写完整信息',
          type: 'warning'
        });
        return;
      }

      //   验证身份证号
      var chineseIDCardNumberRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
      if (!chineseIDCardNumberRegex.test(this.userform.card_code)) {
        this.$message({
          message: '身份证号格式错误',
          type: 'warning'
        });
        return;
      }

      // 验证手机号
      var chinesePhoneNumberRegex = /^1[3456789]\d{9}$/;
      if (!chinesePhoneNumberRegex.test(this.userform.mobile)) {
        this.$message({
          message: '手机号格式错误',
          type: 'warning'
        });
        return;
      }
      (0, _request.default)({
        url: "/system/shopConfig/setFengKongUser/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          mobile: this.userform.mobile,
          real_name: this.userform.real_name,
          card_code: this.userform.card_code
        }
      }).then(function (response) {
        _this2.dialogVisiblerisk = false;
        _this2.getUserList();
        // this.listLoading = false
      });
    },
    handleClick: function handleClick(url, e) {
      this.$router.push({
        name: url,
        query: {
          user_id: e.id
        }
      });
      //   console.log('携带用户id参数跳转查询记录列表页，同步取消用户信息查询框，显示用户信息')
      //   this.$router.push({ name: 'ReportTable', query: { id:e.id,type:e.remark+'_money' }})
    }
  }
};